import * as React from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import {
  updateTerminalCall,
} from "../../data/terminalcall";
import { useDispatch, useSelector } from "react-redux";
import { TerminalCall } from "../../types/TerminalCall";
import { DateTimeField } from "../FormFields/RenderDateTimeField";
import { hideModal } from "../../data/modal";

import { Button, Grid } from "@mui/material";
import {
  Save as SaveIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { useRefreshVoyageData } from "../hooks/useRefreshVoyageData";
import { selectedFilteredVoyage } from "../../selectors/filterSelector";

interface TerminalCallCompletionFormProps {
  terminalCall: TerminalCall;
  type?: keyof TerminalCall;
}

const TerminalCallDatetimeForm: React.FC<TerminalCallCompletionFormProps> = ({
  terminalCall,
  type = "planned",
  title = undefined,
}) => {
  const dispatch = useDispatch();
  const current = new Date();
  const { voyage } = useSelector(selectedFilteredVoyage);
  const refreshVoyageData = useRefreshVoyageData();

  const defaultValues: Partial<TerminalCall> = {
    ...terminalCall,
    [type]: terminalCall[type] ?? current,
  };

  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
  } = useForm<TerminalCall>({ defaultValues });

  const onSubmit: SubmitHandler<TerminalCall> = async (data) => {
    const updated: TerminalCall = {
      ...terminalCall,
      ...data,
    };

    await dispatch(updateTerminalCall(updated));
    refreshVoyageData(voyage).then(() => dispatch(hideModal()));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container>
        <Grid item xs={12} sm={12}>
          <Grid item xs={12}>
            <Grid item xs={12} className="form-fields-container">
              <Grid item xs={12} sm={12} className="form-field-datetime">
                <DateTimeField
                  name={type}
                  label={ title ?? type.charAt(0).toUpperCase() + type.slice(1) }
                  control={control}
                  required
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} className="button-wrapper" mt={2}>
        <Button
          onClick={() => dispatch(hideModal())}
          disabled={isSubmitting}
          variant="contained"
          size="small"
        >
          <CloseIcon fontSize="inherit" />
          &nbsp;Close
        </Button>
        <Button
          type="submit"
          disabled={isSubmitting}
          variant="contained"
          size="small"
          sx={{ ml: 1 }}
        >
          <SaveIcon fontSize="inherit" />
          &nbsp;Save
        </Button>
      </Grid>
    </form>
  );
};

export default TerminalCallDatetimeForm;